export const REDUCE_GET_NEW_MESSAGE = 'REDUCE_GET_NEW_MESSAGE';
export const REDUCE_UPDATE_NEW_MESSAGE = 'REDUCE_UPDATE_NEW_MESSAGE';

export const SAGA_GET_CURRENT_PST = 'SAGA_GET_CURRENT_PST';
export const SAGA_GET_PST_By_Vigo = 'SAGA_GET_PST_By_Vigo';

export const REDUCER_GET_CURRENT_PST = 'REDUCER_GET_CURRENT_PST';

export const SAGA_GET_QA_DICT_TYPE_GROUP = 'SAGA_GET_QA_DICT_TYPE_GROUP';
export const REDUCE_GET_QA_DICT_TYPE_GROUP = 'REDUCE_GET_QA_DICT_TYPE_GROUP';

export const SAGA_USER_LOGOUT = 'SAGA_USER_LOGOUT';

//打电话相关
export const REDUCE_SET_CALL_INSTANCE = 'REDUCE_SET_CALL_INSTANCE';//打电话应用实例
export const REDUCE_SET_CALLING_STATUS = 'REDUCE_SET_CALLING_STATUS';//当前通话所处的状态
export const REDUCE_SET_CALL_SYSTEM_STATUS = 'REDUCE_SET_CALL_SYSTEM_STATUS';//话务系统统一状态
export const REDUCE_SET_CALL_INIT_STATUS = 'REDUCE_SET_CALL_INIT_STATUS';//初始化话务状态的状态
export const REDUCE_SET_CALL_PLATFORM_STATUS = 'REDUCE_SET_CALL_PLATFORM_STATUS';//桌面端/浏览器
export const REDUCE_SET_CALLING_ID = 'REDUCE_SET_CALLING_ID';//正在通话的任务的唯一标识（当用离开当前任务后又重新回来需要通过此ID来区分是否正在通话中）
export const REDUCE_SET_WARNING = 'REDUCE_SET_WARNING';//警告提示，提示踢下线啥的功能


